import React from 'react';
import { m } from 'framer-motion';
import { UsersIcon, Building2Icon, DownloadIcon, ClockIcon, GraduationCapIcon, LayersIcon, SmartphoneIcon } from 'lucide-react';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const stats = [{
  icon: UsersIcon,
  value: '+8K',
  label: 'Entrenadores activos'
}, {
  icon: Building2Icon,
  value: '900+',
  label: 'Clubes y Colegios'
}, {
  icon: DownloadIcon,
  value: '+180.000',
  label: 'Sesiones descargadas'
}, {
  icon: ClockIcon,
  value: '+4 horas',
  label: 'Ahorradas / semana'
}];
const trustBadges = [{
  icon: GraduationCapIcon,
  title: 'Base Técnica',
  text: 'Diseñado por Javier Solana (14 años de exp, +600 jugadores formados).'
}, {
  icon: LayersIcon,
  title: 'Todas las Edades',
  text: 'Desde los 6 hasta los 18 años, con progresiones adaptadas a cada etapa.'
}, {
  icon: SmartphoneIcon,
  title: 'Multidispositivo',
  text: 'Tablet, móvil, PC o para imprimir — úsalo donde te quede cómodo.'
}];
export function TrustStats() {
  return <section className="border-y border-white/5 bg-bg-secondary py-8 sm:py-10" data-id="element-267" data-mp="191oxe8jj2heg">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-268" data-mp="1dv1kge8k6g53">
        <ScrollHintTable minWidth="640px" data-id="element-269" data-mp="1dvt2snd5ahdf">
          <div className="grid grid-cols-4 divide-x divide-white/10" data-id="element-270" data-mp="z651vn8vlkq8">
            {stats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-271" data-mp="144yj9qra9vvo" data-mpi={i}>
                <stat.icon size={22} className="text-orange" data-id="element-272" data-mp="1muekyhepfudo" />
                <span className="font-heading text-xl font-bold text-white sm:text-2xl" data-id="element-273" data-mp="1mwrbvk2fxf2v">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-274" data-mp="7g0jtv8l99s6">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-semibold uppercase tracking-wider text-success" data-id="element-275" data-mp="2e153sag99vtd">
          ✓ Recursos Profesionales para Entrenadores
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-276" data-mp="24bvbathi2b4q">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-bg-primary p-5" data-id="element-277" data-mp="1ze24by8dhd3e" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-orange/10" data-id="element-278" data-mp="1lfc449q9axat">
                <badge.icon size={20} className="text-orange" data-id="element-279" data-mp="3fra2thqxwasg" />
              </div>
              <div data-id="element-280" data-mp="3fp5zp20v7ft8">
                <p className="font-heading text-sm font-semibold text-white" data-id="element-281" data-mp="3arxip4rgdhtk">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-282" data-mp="3j9poahm06uom">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}